<template>
  <div v-if="show" data-canvas-frame-overlay></div>
</template>
<style>
[data-canvas-frame-overlay] {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: none;
}
</style>
<script>
export default {
  data() {
    return { show: false };
  },
  created() {
    this.$canvas.on('drag:start', () => {
      this.show = true;
    });
    this.$canvas.on('drag:stop', () => {
      this.show = false;
    });
  }
};
</script>
